export function GetParam(url, id) {
    url = url+ "";
    let regstr = "/(\\?|\\&)" + id + "=([^\\&]+)/";
    let reg = eval(regstr);
    let result = url.match(reg);
    if (result && result[2]) {
        return result[2];
    }
}


// WEBPACK FOOTER //
// ./src/utils/param.js